import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import HomeView from '../views/HomeView.vue'
import AdminUsuarios from '../views/Usuarios/AdminUsuarios.vue'
import NuevoAlumno from '@/views/Usuarios/NuevoUsuario.vue'
import AdminPreguntas from '@/views/Preguntas/AdminPreguntas.vue'

import NotificarAlumnos from '@/views/Usuarios/NotificarAlumnos.vue'
import UsoUsuarios from '@/views/Usuarios/UsoUsuarios.vue'

import IngresoMasivo from '@/views/Usuarios/IngresoMasivo.vue'
import IngresoMasivoApoderado from '@/views/Usuarios/IngresoMasivoApoderado.vue'
import IngresoJefaturas from '@/views/Usuarios/IngresoJefatura.vue'
import IngresoMasivoProfesor from '@/views/Usuarios/IngresoMasivoProfesor.vue'


import AdminMasivo from '@/views/AdminMasivo.vue'
import AdminUso from '@/views/AdminUso.vue'

import InformeUso from '@/views/Usuarios/InformeUso.vue'
import UsoVideo from '@/views/Usuarios/UsoVideo.vue'
import UsoTest from '@/views/Usuarios/UsoTest.vue'
import UsoPracticas from '@/views/Usuarios/UsoPracticas.vue'

import UsoPracticasMultiple from '@/views/Usuarios/UsoPracticasMultiple.vue'

import InformeCumplimientoTest from '@/views/Usuarios/InformeCumplimientoTest.vue'
import InformeInteraccionTest from '@/views/Usuarios/InformeIntereaccionTest.vue'
import InformeVisualizacionVideo from '@/views/Usuarios/InformeVisualizacionVideo.vue'

import InformeInteraccionJuego from '@/views/Usuarios/InformeInteraccionJuego.vue'
import InformeCumplimientoJuego from '@/views/Usuarios/InformeCumplimientoJuego.vue'


import InformeInteraccionTotal from '@/views/Usuarios/InformeTotal.vue'

import ActualizarCasaMasivo from '@/views/Usuarios/ActualizaCasaMasivo.vue'

import MasivoVideo from '@/views/Masivo/ingresoVideos.vue'
import IngresoCapitulos from '@/views/Masivo/IngresoCapitulos.vue'
import RelacionVideoCap from '@/views/Masivo/RelacionVideoCap.vue'
import IngresoPreguntas from '@/views/Masivo/IngresoPreguntas.vue'
import IngresoPreguntas2 from '@/views/Masivo/IngresoPreguntas2.vue'

import CapitulosNoVigentes from '@/views/Capitulo/CapitulosNoVigentes.vue'
import OrdenCapituloEnUnidad from '@/views/Capitulo/OrdenCapituloEnUnidad.vue'


import ReporteImagenesPreguntas from '@/views/Preguntas/ReporteImagenesPreguntas.vue'

import CumplimientoPracticas from '@/views/Usuarios/CumplimientoPracticas.vue'

const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/',
    name: 'login',
    component: LoginPage
  },

  

  {
    path: '/actualiza-masivo-casas-alumno',
    name: 'actualiza-masivo-casas-alumno',
    component: ActualizarCasaMasivo,
    meta: {
      formulario: 'Usuarios'
    }
  },

{
    path: '/informe-interaccion-total',
    name: 'informe-interaccion-total',
    component: InformeInteraccionTotal,
    meta: {
      formulario: 'Usuarios'
    }
  },

{
    path: '/informe-cumplimiento-juego',
    name: 'informe-cumplimiento-juego',
    component: InformeCumplimientoJuego,
    meta: {
      formulario: 'Usuarios'
    }
  },
  {
    path: '/informe-interaccion-juego',
    name: 'informe-interaccion-juego',
    component: InformeInteraccionJuego,
    meta: {
      formulario: 'Usuarios'
    }
  },

  {
    path: '/informe-visualizacion-video',
    name: 'informe-visualizacion-video',
    component: InformeVisualizacionVideo,
    meta: {
      formulario: 'Usuarios'
    }
  },

  {
    path: '/informe-interaccion-test',
    name: 'informe-interaccion-test',
    component: InformeInteraccionTest,
    meta: {
      formulario: 'Usuarios'
    }
  },

  {
    path: '/informe-cumplimiento-test',
    name: 'informe-cumplimiento-test',
    component: InformeCumplimientoTest,
    meta: {
      formulario: 'Usuarios'
    }
  },

  {
    path: '/admin-alumno',
    name: 'admin-alumno',
    component: AdminUsuarios,
    meta: {
      formulario: 'Usuarios'
    }
  },

    {
    path: '/admin-uso',
    name: 'admin-uso',
    component: AdminUso,
    meta: {
      formulario: 'Admin Uso Usuarios'
    }
  },

  {
    path: '/uso-curso',
    name: 'uso-curso',
    component: InformeUso,
    meta: {
      formulario: 'Uso Usuarios por curso'
    }
  },

  {
    path: '/uso-video',
    name: 'uso-video',
    component: UsoVideo,
    meta: {
      formulario: 'Uso Video por curso'
    }
  },

  {
    path: '/uso-test',
    name: 'uso-test',
    component: UsoTest,
    meta: {
      formulario: 'Uso Test por curso'
    }
  },

   {
    path: '/uso-practica',
    name: 'uso-practica',
    component: UsoPracticas,
    meta: {
      formulario: 'Uso Practica por curso'
    }
  },


  {
    path: '/cumplimiento-practicas',
    name: 'cumplimiento-practicas',
    component: CumplimientoPracticas,
    meta: {
      formulario: 'Cumplimiento Practica por curso'
    }
  },

   {
    path: '/uso-practica-multiple',
    name: 'uso-practica-multiple',
    component: UsoPracticasMultiple,
    meta: {
      formulario: 'Uso Practica por curso'
    }
  },

    {
    path: '/reporte-imagenes-preguntas',
    name: 'reporte-imagenes-preguntas',
    component: ReporteImagenesPreguntas,
    meta: {
      formulario: 'Preguntas'
    }
  },

  {
    path: '/capitulos-no-vigente',
    name: 'capitulos-no-vigente',
    component: CapitulosNoVigentes,
    meta: {
      formulario: 'Capitulos'
    }
  },

  {
    path: '/orden-capitulos-en-unidades',
    name: 'orden-capitulos-en-unidades',
    component: OrdenCapituloEnUnidad,
    meta: {
      formulario: 'Capitulos'
    }
  },

  {
    path: '/admin-alumno',
    name: 'admin-alumno',
    component: AdminUsuarios,
    meta: {
      formulario: 'Usuarios'
    }
  },

  {
    path: '/admin-masivo',
    name: 'admin-masivo',
    component: AdminMasivo,
    meta: {
      formulario: 'Menu Masivo'
    }
  },

   {
    path: '/ingreso-masivo-apoderado',
    name: 'ingreso-masivo-apoderado',
    component: IngresoMasivoApoderado,
    meta: {
      formulario: 'Menu Masivo'
    }
  },


  {
    path: '/ingreso-masivo-profesor',
    name: 'ingreso-masivo-profesor',
    component: IngresoMasivoProfesor,
    meta: {
      formulario: 'Menu Masivo'
    }
  },


  

  {
    path: '/ingreso-masivo-videos',
    name: 'ingreso-masivo-videos',
    component: MasivoVideo,
    meta: {
      formulario: 'Masivo Videos'
    }
  },


  {
    path: '/ingreso-masivo-capitulos',
    name: 'ingreso-masivo-capitulos',
    component: IngresoCapitulos,
    meta: {
      formulario: 'Masivo Capitulos'
    }
  },



  {
    path: '/relacion-video-capitulo',
    name: 'relacion-video-capitulo',
    component: RelacionVideoCap,
    meta: {
      formulario: 'Masivo Relacion Video Capitulo'
    }
  },

  

  


  {
    path: '/uso-alumnos',
    name: 'uso-alumnos',
    component: UsoUsuarios,
    meta: {
      formulario: 'Uso Alumnos'
    }
  },

  {
    path: '/notificar-alumnos',
    name: 'notificar-alumnos',
    component: NotificarAlumnos,
    meta: {
      formulario: 'Notificar Alumnos'
    }
  },

  {
    path: '/admin-preguntas',
    name: 'admin-preguntas',
    component: AdminPreguntas,
    meta: {
      formulario: 'Preguntas'
    }
  },

  {
    path: '/admin-alumnos-nuevo/:id_usuario?',
    name: 'admin-alumnos-nuevo',
    component: NuevoAlumno,
    meta: {
      formulario: 'Nuevo Usuario'
    }
  },

  {
    path: '/ingreso-masivo-alumno/',
    name: 'ingreso-masivo-alumno',
    component: IngresoMasivo,
    meta: {
      formulario: 'Masivo Alumno'
    }
  },

  {
    path: '/ingreso-masivo-preguntas/',
    name: 'ingreso-masivo-preguntas',
    component: IngresoPreguntas,
    meta: {
      formulario: 'Masivo Preguntas'
    }
  },

    {
    path: '/ingreso-preguntas-nuevo',
    name: 'ingreso-preguntas-nuevo',
    component: IngresoPreguntas2,
    meta: {
      formulario: 'Ingreso Preguntas'
    }
  },

  {
    path: '/ingreso-jefaturas',
    name: 'ingreso-jefaturas',
    component: IngresoJefaturas // Nombre del componente
},



  {
    name: 'logout',
    path: '/logout',
    redirect: to => {
        console.log(to);
        return {name: 'login'};
    },
    meta: {
        requiresAuth: false,
        module: 'authentication'
    }
},

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
